import aeliaLogoLarge from '~shared/assets/images/group-logos/aelia-large.png';
import aeliaLogoSquare from '~shared/assets/images/group-logos/aelia-square.png';
import aptipharLogoLarge from '~shared/assets/images/group-logos/aptiphar-large.png';
import aptipharLogoSquare from '~shared/assets/images/group-logos/aptiphar-square.png';
import giropharmLogoLarge from '~shared/assets/images/group-logos/giropharm-large.png';
import giropharmLogoSquare from '~shared/assets/images/group-logos/giropharm-square.png';
import pharmabestLogoLarge from '~shared/assets/images/group-logos/pharmabest-large.png';
import pharmabestLogoSquare from '~shared/assets/images/group-logos/pharmabest-square.png';
import valwinLogoLarge from '~shared/assets/images/group-logos/valwin-large.png';
import valwinLogoSquare from '~shared/assets/images/group-logos/valwin-square.png';

type GroupName =
  | 'pharmabest'
  | 'giropharm'
  | 'aptiphar'
  | 'aelia'
  | 'pharmabest-es';
type Size = 'small' | 'large';

type Groups = { [key in GroupName]: { [key in Size]: string } };

const groups: Groups = {
  'pharmabest-es': {
    small: pharmabestLogoSquare,
    large: pharmabestLogoLarge,
  },
  pharmabest: {
    small: pharmabestLogoSquare,
    large: pharmabestLogoLarge,
  },
  giropharm: {
    small: giropharmLogoSquare,
    large: giropharmLogoLarge,
  },
  aptiphar: {
    small: aptipharLogoSquare,
    large: aptipharLogoLarge,
  },
  aelia: {
    small: aeliaLogoSquare,
    large: aeliaLogoLarge,
  },
};

export function getLogo({ group, size }: { group: string; size: Size }) {
  if (size === 'small') {
    return groups[group as GroupName]?.small || valwinLogoSquare;
  }

  return groups[group as GroupName]?.large || valwinLogoLarge;
}
